import moment from 'moment'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import InventoryTransferPDF from 'src/PDF/InventoryTransferPDF'

export const INVENTORY_TRANSFER_STATUS_JUST_PLACED = 1
export const INVENTORY_TRANSFER_STATUS_APPROVED = 2
export const INVENTORY_TRANSFER_STATUS_CANCELLED = 3
export const INVENTORY_TRANSFER_STATUS_REVIEWED = 4

export const INVENTORY_TRANSFER_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Cancelled',
  4: 'Reviewed',
}

export const INVENTORY_TRANSFER_STATUS_DROPDOWN_OPTIONS = [
  {
    value: INVENTORY_TRANSFER_STATUS_JUST_PLACED,
    label: INVENTORY_TRANSFER_STATUS_NAME[INVENTORY_TRANSFER_STATUS_JUST_PLACED],
  },
  {
    value: INVENTORY_TRANSFER_STATUS_APPROVED,
    label: INVENTORY_TRANSFER_STATUS_NAME[INVENTORY_TRANSFER_STATUS_APPROVED],
  },
  {
    value: INVENTORY_TRANSFER_STATUS_CANCELLED,
    label: INVENTORY_TRANSFER_STATUS_NAME[INVENTORY_TRANSFER_STATUS_CANCELLED],
  },
  {
    value: INVENTORY_TRANSFER_STATUS_REVIEWED,
    label: INVENTORY_TRANSFER_STATUS_NAME[INVENTORY_TRANSFER_STATUS_REVIEWED],
  },
]

export const InventoryTransferModel = {
  from_warehouse_id: 0,
  from_warehouse: { name: '' },
  transfer_date: moment().format('YYYY-MM-DD'),
  status: INVENTORY_TRANSFER_STATUS_JUST_PLACED,
  reviewed_at: '',
  reviewed_by_id: null,
  reviewed_by: { name: '' },
  approved_at: '',
  approved_by_id: null,
  approved_by: { name: '' },
  created_by_id: 0,
  created_by: { name: '' },
  created_at: '',
  updated_by_id: 0,
  updated_by: { name: '' },
  updated_at: '',
  inventory_transfer_request_id: null,
  inventory_transfer_details: [],
}

export const generateGatePassPdf = (id) => {
    wtApiCall(
      'inventory_transfer_pdf/' + id,
      {},
      'get',
      (response) => {
        const { data } = response
        InventoryTransferPDF(data)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }
